import React from "react";
import { Box } from "@mui/material";
import { specsGlow } from "./specsTheme";

const SpecsHeader = () => (
  <Box
    component="header"
    sx={{
      position: "relative",
      zIndex: 3,
      flexShrink: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      px: "clamp(16px, 3vw, 40px)",
      pt: "clamp(8px, 1.6vh, 18px)",
      pb: "clamp(2px, 0.6vh, 8px)",
    }}
  >
    <Box
      component="img"
      src="/MindYourMusic.png"
      alt="Mind Your Music"
      sx={{
        height: "clamp(40px, 8vh, 72px)",
        "@media (min-width: 900px)": {
          height: "clamp(56px, 12vh, 140px)",
        },
        width: "auto",
        maxWidth: "min(78vw, 520px)",
        objectFit: "contain",
        animation: `${specsGlow} 4.5s ease-in-out infinite`,
        flexShrink: 1,
        minHeight: 0,
      }}
    />
  </Box>
);

export default SpecsHeader;
